<ngx-charts-bar-horizontal-2d
  [view]="view"
  [results]="data"
  [xAxis]="axis?.showXAxis"
  [yAxis]="axis?.showYAxis"
  [xAxisLabel]="axis?.xAxisLabel"
  [yAxisLabel]="axis?.yAxisLabel"
  [showXAxisLabel]="axis?.xAxisLabel"
  [showYAxisLabel]="axis?.yAxisLabel"
  [gradient]="enableGradient"
  [animations]="enableAnimations"
  [legend]="legend?.visible || true"
  [legendTitle]="legend?.title || 'Legend'"
  [legendPosition]="legend?.position || 'right'"
  [showGridLines]="showGridLines"
  [showDataLabel]="showDataLabel"
  [tooltipDisabled]="tooltipDisabled"
  [barPadding]="barPadding"
  [groupPadding]="groupPadding"
  (select)="onSelect($event)"
>
</ngx-charts-bar-horizontal-2d>
